<template>
  <div>
    <form>

      <div class="row">
        <div class="col-md-6">
          <fg-input class="clean" type="text" label="Nome Completo" placeholder="Carlos" v-model="data.name"
            v-bind:readonly="readonly" />
        </div>

        <div class="col-md-6">
          <fg-input class="clean" type="email" label="E-mail" placeholder="carlos.andrade@gmail.com" v-model="data.email"
            v-bind:readonly="readonly" />
        </div>

        <div class="col-md-4">
          <fg-input class="clean" type="text" label="Data de Nascimento" placeholder="  /  /    " v-mask="'##/##/####'"
            v-model="data.birthday" v-bind:readonly="readonly" />
        </div>

        <div class="col-md-4">
          <fg-input class="clean" type="text" label="Telefone" placeholder="(  )      -     " v-mask="'(##) #####-####'"
            v-model="data.formattedPhone" v-bind:readonly="readonly" />
        </div>

         <div class="col-md-4">
          <fg-input class="clean" type="text" label="CPF ou CNPJ" placeholder="CPF ou CNPJ" v-mask="('' + data.cpfcnpj).onlyNumber().length > 11 ? '##.###.###/####-##' : '###.###.###-##' "
            v-model="data.cpfcnpj" v-bind:readonly="readonly" />
        </div>

          <!-- <div class="col-md-6">
          <fg-select
              :options="isIndustry"
              v-model="data.isIndustry"
              :selected="data.isIndustry"
              label="É lojistas?"
              :readonly="readonly"
            />
        </div> -->

          <div class="col-md-6">
          <fg-select
              :options="isSeller"
              v-model="data.isSeller"
              :selected="data.isSeller"
              label="É Vendedor(a)?"
              :readonly="readonly"
            />
        </div>

      <div class="col-md-12 ">
          <h5 class="input-group-title" v-if="edit && !readonly">
            Alterar Senha
          </h5>
          <div class="col-md-6 no-padding" v-if="!readonly">
            <fg-input type="password" label="Senha" placeholder="Senha" v-model="data.password" />
          </div>
          <div class="col-md-6" v-if="!readonly">
            <fg-input type="password" label="Confirmar Senha" placeholder="Senha" v-model="data.confirmPassword" />
          </div>
        </div>
      </div>
    </form>

  </div>
</template>

<script>
  import {
    mapActions,
    mapState,
    mapGetters
  } from "vuex";
  import ClientForm from "./ClientForm";
  import moment from 'moment';

  export default {
    name: "user-form",
    components: {
      ClientForm
    },

    props: {
      data: {
        type: Object,
      },
      readonly: {
        type: Boolean,
        default: false
      },
      event: {
        type: String,
        default: ''
      },
      edit: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      ...mapState({
        operatorList: ({
          operator
        }) => operator.list.map((obj) => {
          return {
            name: obj.name,
            value: obj.id
          }
        })
      })
    },

    methods: {
      ...mapActions([""]),
      ...mapGetters({
        sidebarFlag: 'sidebarFlag'
      }),
      unlock() {
        if (this.sidebarFlag() === 'ADMIN') {
          this.localReadonly = !this.localReadonly
        } else {
          this.localReadonly = true;
        }
      },
      getInvitedByURL(invited) {
        if (!invited) return '';
        let path = window.location.pathname === '/' ? '' : window.location.pathname;
        return `${path}/?#/admin/usuarios/editar/${invited.sharingCode}`;
      },
      formatDate(date) {
        return moment.utc(date).utcOffset(-180).format('D/M/YYYY H:mm:ss')
      }
    },

    created() {

      this.$on("execute", () => {
        this.$parent.$emit(this.event, this.data);
      });

    },
    data() {
      return {
        localReadonly: false,
        isIndustry: [
          {
            name: "Sim",
            value: true
          },
          {
            name: "Não",
            value: false
          }
        ],
        isSeller: [
          {
            name: "Sim",
            value: true
          },
          {
            name: "Não",
            value: false
          }
        ]
      };
    },

  };
</script>

<style scoped lang="scss">

label.stronger {
  font-weight: bold;
  color: black;
}

.stronger {
  font-weight: bold;
  color: black;
  margin: 15px 0 0 0 !important;
}

p.subject {
  color: #9c9c9c;
}

</style>



// WEBPACK FOOTER //
// src/components/UIComponents/Forms/ClientForm.vue